import { useState, useEffect } from "react";
import DistributorChangeStatusPop from "./DistributorChangeStatusPop";
import editDistributorLocation from "../api/editDistributorLocation";
import getRegionsAPI from "../../Regions/api/getRegionsAPI";
import editDistributorRegion from "../api/editDistributorRegion";
import { IoIosSend } from "react-icons/io";
import DistributorSendMessagePop from "./DistributorSendMessagePop";
import SendPasswordDistributor from "../api/sendPasswordDistributor";

const DistributorComponent = ({ distributor, setAlert, setAlertData }) => {
    const [distributorPop, setDistributorPop] = useState(false);
    const [distributorSendMessagePop, setDistributorSendMessagePop] = useState(false);
    const [location, setLocation] = useState(distributor.location);
    const [status, setStatus] = useState(0);
    const [regions, setRegions] = useState([]);
    const [distributorRegion, setDistributorRegion] = useState(distributor.region);

    // using setClient Status for Update Status when load components
    useEffect(() => {
        setStatus(distributor.status);
        setLocation(distributor.location);
        const fetchRegions = async () => {
            const regions = await getRegionsAPI();
            await setRegions(regions);
        };
        fetchRegions();
    }, [distributor]);

    // using for Change Distributor Status Show Pop
    const toggleDistributorPop = () => {
        setDistributorPop((prev) => !prev);
    };

    // using for Show Distributor Send Message Box Pop;
    const toggleSendMessagePop = () => {
        setDistributorSendMessagePop((prev) => !prev);
    };

    // handle Distribute location
    const handleDistributorLocation = async () => {
        // change User Location
        let res = await editDistributorLocation({
            distributorId: distributor.id,
            new_location: location,
        });
        if (res) {
            setAlertData({
                status: "success",
                title: "تحديث الموقع الجغرافي",
                content: `تم تحديث الموقع الجغرافي للعميل ${distributor.name} `,
            });
        } else {
            setAlertData({
                status: "error",
                title: "خطا أثناء تحديث الموقع الجغرافي",
                content: `حدث خطا ما في تحديث الموقع الجغرافي للعميل ${distributor.name}`,
            });
        }
        // Show Alert
        setAlert(true);
        setTimeout(() => {
            setAlert(false);
        }, 5000);
    };

    const handleChangeRegion = async (value) => {
        let res = await editDistributorRegion({
            distributorId: distributor.id,
            new_region_id: value,
        });
        if (res) {
            await setDistributorRegion(value);
            setAlertData({
                status: "success",
                title: "تحديث عنوان العميل",
                content: `تم تحديث عنوان العميل  ${distributor.name}`,
            });
        } else {
            setAlertData({
                status: "error",
                title: "خطا أثناء تحديث عنوان العميل",
                content: `حدث خطا ما في تحديث عنوان  العميل ${distributor.name}`,
            });
        }
        // Show Alert
        setAlert(true);
        setTimeout(() => {
            setAlert(false);
        }, 5000);
    };

    const sendPasswordForDistributor = async () => {
        const response = await SendPasswordDistributor({
            distributor_id: distributor.id,
        });
        if (response) {
            setAlertData({
                status: "success",
                title: "ثم إرسال كلمة السر إلى العميل",
            });
        } else {
            setAlertData({
                status: "error",
                title: "حدث خطا إثناء إرسال كلمة السر إلى العميل",
            });
        }
        // Show Alert
        setAlert(true);
        setTimeout(() => {
            setAlert(false);
        }, 5000);
    };
    return (
        <>
            <tr className=" bg-gray-100 border-b">
                <td className="px-6 py-4 text-gray-900 text-center font-semibold">
                    <button
                        className="flex  flex-row-reverse"
                        onClick={() => sendPasswordForDistributor()}
                    >
                        <spam className=" text-blue-600">إرسال كلمة السر</spam>
                    </button>
                </td>
                <td className="px-6 py-4 text-gray-900 text-center font-semibold">
                    <button
                        className="flex p-2 flex-row-reverse"
                        onClick={() => toggleSendMessagePop()}
                    >
                        <spam className="px-1 text-blue-600">إرسال رسالة</spam>{" "}
                        <spam className="text-blue-600">
                            <IoIosSend />
                        </spam>
                    </button>
                    {distributorSendMessagePop && (
                        <DistributorSendMessagePop
                            distributor={distributor}
                            toggleSendMessagePop={toggleSendMessagePop}
                        />
                    )}
                </td>
                <td className="px-6 py-4 text-gray-900 text-center font-semibold">
                    <button
                        className="text-blue-700 font-medium rounded-lg text-sm px-1 py-2.5 text-center"
                        onClick={() => toggleDistributorPop()}
                    >
                        تغيير الحالة /
                    </button>

                    {status === 1 ? "عميل فعال" : "عميل غير فعال"}
                    {distributorPop && (
                        <DistributorChangeStatusPop
                            distributor={distributor}
                            setStatus={setStatus}
                            toggleDistributorPop={toggleDistributorPop}
                        />
                    )}
                </td>
                <td className="px-6 py-4 text-gray-900 text-center font-semibold">
                    <button
                        className="text-blue-700 font-medium rounded-lg text-sm px-1 py-2.5 text-center"
                        onClick={() => handleDistributorLocation()}
                    >
                        تغيير الموقع /
                    </button>

                    <input
                        type="text"
                        className="py-2 px-4 border rounded"
                        value={location}
                        onChange={(e) => setLocation(e.target.value)}
                        dir="rtl"
                    />
                </td>

                <th className="px-6 py-4 text-gray-900 text-center font-semibold">
                    {distributor.phone}
                </th>

                <th className="px-6 py-4 text-gray-900 text-center font-semibold">
                    <div className="relative mb-4 flex w-full flex-col items-end">
                        {regions ? (
                            <select
                                dir="rtl"
                                value={distributorRegion}
                                required
                                onChange={(e) => handleChangeRegion(e.target.value)}
                                className="w-full rounded border border-gray-300 bg-white px-3 py-1 text-base leading-8 text-gray-700 outline-none transition-colors duration-200 ease-in-out focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200"
                            >
                                {regions.map((region) => (
                                    <option value={region.id} key={region.id}>
                                        {region.name}
                                    </option>
                                ))}
                            </select>
                        ) : (
                            ""
                        )}
                    </div>
                </th>

                <th className="px-6 py-4 text-gray-900 text-center font-semibold">
                    {distributor.name}
                </th>
            </tr>
        </>
    );
};

export default DistributorComponent;
